import MicroModal from "micromodal";

const DISMISS_KEY = 'installAppDismissedAt';
const DISMISS_DELAY = 30 * 86400000;

let installPrompt = null;

function isInstalled() {
  return document.documentElement.classList.contains('pwa');
}

function isIos() {
  const ua = navigator.userAgent;
  return /iphone|ipad|ipod/i.test(ua) || (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
}

function isMobile() {
  return window.matchMedia('(pointer: coarse)').matches;
}

function recentlyDismissed() {
  const dismissedAt = parseInt(localStorage.getItem(DISMISS_KEY));
  return dismissedAt > 0 && Date.now() - dismissedAt < DISMISS_DELAY;
}

function canOfferInstall() {
  return !isInstalled() && isMobile() && !recentlyDismissed();
}

function hideInstallButton() {
  document.querySelector('#install_app').classList.add('hidden');
}

window.addEventListener('beforeinstallprompt', (evt) => {
  if (!canOfferInstall()) {
    return;
  }
  evt.preventDefault();
  installPrompt = evt;
  document.querySelector('#install_app').classList.remove('hidden');
});

window.addEventListener('appinstalled', () => {
  installPrompt = null;
  hideInstallButton();
});

export function initInstallButton() {
  if (isIos() && canOfferInstall()) {
    document.querySelector('#install_app').classList.remove('hidden');
  }
}

export function installApp() {
  if (installPrompt) {
    installPrompt.prompt();
    installPrompt.userChoice.then(() => {
      installPrompt = null;
      hideInstallButton();
    });
  } else {
    MicroModal.show('install_modal', {disableScroll: true});
  }
}

export function dismissInstallButton() {
  localStorage.setItem(DISMISS_KEY, Date.now().toString());
  hideInstallButton();
}
